import { RESTART_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type RestartPaymentPackageRequest = {
  consecutive: string;
  motive: string;
  detail: string;
  attachmentId?: number;
};

export type RestartPaymentPackageResponse = {
  id: number;
  consecutive: string;
};

export const restartPaymentPackage = async (
  data: RestartPaymentPackageRequest,
): Promise<RestartPaymentPackageResponse> => {
  const response = await apiInstance.post<RestartPaymentPackageResponse>(
    RESTART_PAYMENT_PACKAGE,
    data,
  );
  return response.data;
};
